import { useContext, useEffect, useRef, useState } from "react";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@upstageai/ui";
import { useTranslation } from "react-i18next";

import ErrorDialog from "./ErrorDialog";
import {
  ValidatorFileContext,
  ValidatorModelsContext,
} from "../../hooks/useFile";
import { FileUploadCallbacks, FileUploadConfig } from "../../types/upload";
import { endpointStore } from "../../utils/mobx/EndpointStore";
import { cn } from "../../utils/style";
import FileSelectBox from "../Box/FileSelectBox";
import ModelSelectBox from "../Box/ModelSelectBox";
interface DemoSelectDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export default function DemoSelectDialog({
  isOpen,
  setIsOpen,
}: DemoSelectDialogProps) {
  const { t } = useTranslation();
  const { endpointType } = endpointStore;
  // TODO : refactoring
  const [checked, setChecked] = useState<number>(0);
  const { models, selectedModelIndex } = useContext(ValidatorModelsContext);
  const { files, setSelectedFileIndex, setFiles, setInferenceState } =
    useContext(ValidatorFileContext);
  const imageUploadFileRef = useRef<HTMLInputElement | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  const [modelIdx, setModelIndex] = useState<number>(0);

  const [errorOn, setErrorOn] = useState<boolean>(false);
  const [errorType, setErrorType] = useState<number>(1);
  const [errorCloseFunction, setErrorCloseFunction] = useState<() => void>(
    () => {},
  );
  const [errorReloadFunction, setErrorReloadFunction] = useState<() => void>(
    () => {},
  );

  const [hoveredModel, setHoveredModel] = useState<number | null>(null);

  const fileUploadConfig: FileUploadConfig = {
    inputFiles: [] as File[],
    models: models,
    selectedModelIndex: modelIdx,
    files: files,
    errorType: errorType,
    skipValidation: false,
  };

  const fileUploadCallback: FileUploadCallbacks = {
    setErrorType: setErrorType,
    setWorkPercentageVisible: () => {},
    setIsOpen: setIsOpen,
    setErrorOn: setErrorOn,
    setInferenceState: setInferenceState,
    setSelectedFileIndex,
    setFiles: setFiles,
    setErrorCloseFunction: setErrorCloseFunction,
    setErrorReloadFunction: setErrorReloadFunction,
  };

  useEffect(() => {
    setModelIndex(selectedModelIndex);
    setChecked(selectedModelIndex);
  }, [isOpen, selectedModelIndex]);

  return (
    <>
      <ErrorDialog
        open={errorOn}
        setOpen={setErrorOn}
        errorType={errorType}
        errorCloseFunction={errorCloseFunction}
        errorReloadFunction={errorReloadFunction}
      />
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent
          ref={ref}
          className={cn(
            "flex h-fit max-h-[90%] flex-col gap-4 overflow-auto",
            endpointType.toLowerCase() === "extractor"
              ? "max-w-[964px]"
              : "max-w-[600px]",
          )}
        >
          <DialogHeader>
            <DialogTitle>{t(`demo_select.file_upload`)}</DialogTitle>
          </DialogHeader>
          <div className="flex h-full gap-4 mobile:flex-col">
            {endpointType.toLowerCase() === "extractor" && (
              <ModelSelectBox
                models={models}
                selectedModelIndex={modelIdx}
                setSelectedModelIndex={setModelIndex}
                setHoveredModel={setHoveredModel}
                hoveredModel={hoveredModel}
                checked={checked}
                setChecked={setChecked}
                setModelIndex={setModelIndex}
              />
            )}
            <FileSelectBox
              isLogin={true}
              fileUploadConfig={fileUploadConfig}
              fileUploadCallback={fileUploadCallback}
              setErrorType={setErrorType}
              setErrorOn={setErrorOn}
              setErrorCloseFunction={setErrorCloseFunction}
              setErrorReloadFunction={setErrorReloadFunction}
              imageUploadFileRef={imageUploadFileRef}
              t={t}
              endpointUrl={""}
            />
          </div>

          <DialogFooter className="flex h-fit items-end">
            <Button
              variant="ghost"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              {t(`actions.cancel`)}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
